/**
 * Удаляет висящие предлоги, заменяя пробел после них на неразрывный пробел
 * @param text - исходный текст
 * @returns текст с неразрывными пробелами после предлогов
 */
export function removeHangingPrepositions(text: string): string {
    const prepositions =
        // Предлоги
        'в|к|о|с|у|я|на|из|от|по|за|до|об|под|над|при|про|для|без|через|' +
        'во|со|ко|об|обо|ото|изо|предо|передо|надо|подо|' +
        // Союзы
        'а|и|но|да|или|либо|то|не|ни|зато|также|тоже|причем|притом|однако|' +
        'же|ли|бы|ведь|ж|ль|бы|б|' +
        // Частицы
        'не|ни|уж|аж|ух|ах|ох|эх|ну|вот|вон|даже|лишь|только|хоть|пусть|пускай|' +
        // Местоимения и наречия (короткие)
        'я|ты|мы|вы|он|она|оно|они|кто|что|как|где|куда|когда|' +
        'уже|еще|всё|это|эта|эти|мне|тем|чем|мой|твой|наш|ваш|их|его|её|' +
        // Короткие слова
        'ко|ль|аль|буде|дабы|ежели|нежели|коли|раз|ан|благо';

    return text.replace(new RegExp(`(^|\\s)(${prepositions})\\s`, 'gi'), '$1$2\u00A0');
}
